var CrmAnalytics = $.extend(false, BaseModule ,{
    api_route : 'crm/analytics',	
    data : {
        module:'crm-analytics',
        offset:20,
        page:0,
        sort_term:'name',
        sort_way:'ASC',
        status:'',
        type:'subject-template'
    },


    init:function(){
        var module_name = this.data.module,  module = this;
    }
});

$(document).ready(function(){
    "use strict";
    CrmAnalytics.init();
});
